module.exports = __webpack_public_path__ + "img/6.52d2e67f.png";